import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Header, HeadingButtonWrapper, TextWrap } from './MyProfile.styled';
import { ArrowRightFromBracket } from 'assets/icons/Icons';
import { Loader } from 'components/Loader/Loader';
import { Button } from 'components/v2/Buttons/Button/Button';
import { Tabs } from 'components/v2/Tabs/Tabs';
import { Heading } from 'components/v2/Typography/Heading';
import { Text } from 'components/v2/Typography/Text';
import { usePatient } from 'hooks/usePatient/usePatient';
import { ResponsiveContainer } from 'screens/styled_common';
import { analytics, PAGES } from 'utilities/analytics';
import { pageUrl } from 'utilities/pageUrl';
import { useBreakpoints } from 'utilities/useBreakpoints';

import { generateTabs } from './MyProfile.constants';

export function MyProfile() {
  const navigate = useNavigate();
  const { isDesktop } = useBreakpoints();
  const { patient, loading: loadingPatient } = usePatient();
  const tabs = generateTabs(patient);

  const [tabSelected, setTabSelected] = useState(false);

  const onChangeTab = (tabId?: string) => {
    trackTabChange(tabId);
    setTabSelected(!!tabId);
  };

  const handleLogoutClick = () => navigate(pageUrl.logout());

  if (loadingPatient || !patient) return <Loader absoluteCentered />;

  return (
    <ResponsiveContainer $paddedContent>
      <Header $tabSelected={tabSelected}>
        <HeadingButtonWrapper>
          <Heading>My Profile</Heading>
          <Button
            label="Log out"
            uppercase
            category="primary"
            size={isDesktop ? 'md' : 'sm'}
            gap="md"
            leftIcon={<ArrowRightFromBracket type="solid" />}
            onClick={handleLogoutClick}
          />
        </HeadingButtonWrapper>

        <Text tag="span">
          This is the profile information we currently have on file for you.
          <TextWrap>
            <Text tag="strong">All changes are automatically saved.</Text>
          </TextWrap>
        </Text>
      </Header>

      <Tabs tabs={tabs} tabUrlKey="tab" onChangeTab={onChangeTab} />
    </ResponsiveContainer>
  );
}

const trackTabChange = (tabId?: string) => {
  switch (tabId) {
    case 'demographic':
      analytics.page(PAGES.DEMOGRAPHIC_INFORMATION);
      break;
    case 'contact':
      analytics.page(PAGES.CONTACT_INFORMATION);
      break;
    case 'payment-options':
      analytics.page(PAGES.PAYMENT_OPTIONS);
      break;
    case 'partner-invitations':
      analytics.page(PAGES.PARTNER_INVITATIONS);
      break;
    case 'insurance':
      analytics.page(PAGES.INSURANCE);
      break;
    case 'employer':
      analytics.page(PAGES.EMPLOYER_BENEFIT);
      break;
    case 'trustees':
      analytics.page(PAGES.TRUSTEES);
      break;
    case 'care-team':
      analytics.page(PAGES.MY_CARE_TEAM);
      break;
  }
};
